import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("admin_token", r.data.token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch { toast.error("Invalid email or password."); }
    setLoading(false);
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1A1514] px-6">
      <form onSubmit={login} className="bg-[#F9F8F6] rounded-2xl p-10 w-full max-w-sm" data-testid="admin-login-form">
        <p className="font-heading text-3xl text-center">Pascy <span className="text-[#D4AF37]">Lux</span></p>
        <p className="text-center text-sm text-[#1A1514]/50 mt-1 mb-8">Admin Dashboard</p>
        <div className="space-y-4">
          <div><Label className="text-xs">Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" /></div>
          <div><Label className="text-xs">Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" /></div>
        </div>
        <Button type="submit" disabled={loading} data-testid="login-submit"
          className="w-full mt-8 rounded-full bg-[#1A1514] text-[#F9F8F6] hover:bg-[#1A1514]/90 py-6">
          {loading ? "Signing in…" : "Sign In"}
        </Button>

        <div className="flex items-center gap-3 my-5">
          <span className="h-px flex-1 bg-[#1A1514]/10" />
          <span className="text-[11px] uppercase tracking-widest text-[#1A1514]/40">or</span>
          <span className="h-px flex-1 bg-[#1A1514]/10" />
        </div>

        <button type="button" onClick={googleLogin} data-testid="google-login-btn"
          className="w-full flex items-center justify-center gap-3 rounded-full border border-[#1A1514]/15 bg-white py-3 text-sm font-medium text-[#1A1514] hover:bg-[#1A1514]/5 transition-colors">
          <svg className="w-4 h-4" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z" />
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
            <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.2-7.9l-6.5 5C9.6 39.6 16.2 44 24 44z" />
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.6l6.2 5.2C41.9 35.6 44 30.3 44 24c0-1.3-.1-2.3-.4-3.5z" />
          </svg>
          Continue with Google
        </button>

        <a href="/" className="block text-center text-xs text-[#1A1514]/40 mt-6 hover:text-[#1A1514]">← Back to store</a>
      </form>
    </div>
  );
}
